import { RowMenu } from '@components/RowMenu';
import { IMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { MenuItem } from '@material-ui/core';
import IFatura from '@model/Fatura';
import { EnumFaturaStatus } from '@model/FaturaStatus';
import { useFaturaService } from '@services/FaturaService';
import React from 'react';

export type FaturaMenuProps = {
    menu: IMenu
    fatura: IFatura
    cancelarModal: IModalWindow
}

export function FaturaMenu ({ fatura, menu, cancelarModal }: FaturaMenuProps) {
    const faturaService = useFaturaService();
    const message = useMessage();

    const handleBaixarBoleto = React.useCallback(() => {
        faturaService.baixarBoleto(fatura.faturaId)
            .catch(message.showBlobException);
    }, [fatura.faturaId, faturaService, message.showBlobException]);

    return (
        <RowMenu menu={menu}>
            <MenuItem key={0} onClick={menu.handleItemClick(handleBaixarBoleto)}>Baixar Boleto</MenuItem>
            {
                fatura.faturaStatusId === EnumFaturaStatus.Aberta && (
                    <MenuItem key={1} onClick={menu.handleItemClick(cancelarModal.open)}>Cancelar Fatura</MenuItem>
                )
            }
        </RowMenu>
    )
}